import { computedFrom, autoinject, observable } from "aurelia-framework";

@autoinject()
export class ExecutiveDashboardDetails {
}